import { getIdToken } from './okta'

// Attaches the Okta ID token (as X-Id-Token) to every same-origin request to our
// own backend (/api/*). A dedicated header is used instead of Authorization
// because some upstream proxy calls already set Authorization: Basic ... and we
// must not clobber those. Cross-origin requests (e.g. Okta's own token calls)
// are left untouched.
//
// Installed once from index.tsx, before the app renders.

let installed = false

function isOwnApiRequest(input: RequestInfo | URL): boolean {
  try {
    let url: URL
    if (typeof input === 'string') {
      url = new URL(input, window.location.origin)
    } else if (input instanceof URL) {
      url = input
    } else {
      url = new URL((input as Request).url, window.location.origin)
    }
    return url.origin === window.location.origin && url.pathname.startsWith('/api/')
  } catch {
    return false
  }
}

export function installApiAuthInterceptor(): void {
  if (installed) return
  installed = true

  const originalFetch = window.fetch.bind(window)

  window.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    if (!isOwnApiRequest(input)) {
      return originalFetch(input, init)
    }

    const token = getIdToken()
    if (!token) {
      return originalFetch(input, init)
    }

    // Merge the X-Id-Token header without dropping any caller-provided headers.
    const headers = new Headers(
      (init && init.headers) ||
        (input instanceof Request ? input.headers : undefined)
    )
    headers.set('X-Id-Token', token)

    return originalFetch(input, { ...init, headers })
  }
}
